var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import DrawerHeader from "./DrawerHeader";
import DrawerContent from "./DrawerContent";
import { Divider } from "../Divider";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawer-nested-content",
};
const DrawerNestedContent = (_a) => {
    var { children, className, label, open, onNestedDrawerClose } = _a, rest = __rest(_a, ["children", "className", "label", "open", "onNestedDrawerClose"]);
    const classList = classNames("tecma-drawer-nested-content", { open }, className);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx(DrawerHeader, { label: label, onClose: onNestedDrawerClose, isNestedHeader: true }), _jsx(Divider, {}), _jsx(DrawerContent, { children: children })] })));
};
DrawerNestedContent.defaultProps = defaultProps;
export default React.memo(DrawerNestedContent);
